document.querySelectorAll('.events-list[data-events]').forEach((list) => {
  let page = 1;
  const perPage = 16;
  const container = list.querySelector('.cards-grid__container');
  let items = list.querySelectorAll('.event-card');
  const loadMoreButton = list.querySelector('.insights-list__load-more-button');

  if (loadMoreButton && items.length < perPage) {
    loadMoreButton.style.display = 'none';
  }

  loadMoreButton?.addEventListener('click', () => {
    page++;

    loadMoreButton.disabled = true;

    fetch(`${ajaxurl}?action=get_events&page=${page}`)
      .then((response) => response.json())
      .then((data) => {
        container.innerHTML += data.data;

        items = list.querySelectorAll('.event-card');

        if (items.length < perPage * page) {
          loadMoreButton.style.display = 'none';
        } else {
          loadMoreButton.disabled = false;
        }
      });
  });
});